module.exports = __webpack_public_path__ + "img/nav02_h.a8bdd242.png";